/**
 * Normalize budget payload coming from API
 *
 * @param {string|object|null} budget
 * @returns {{
 *   discloseBudget: boolean,
 *   amount: string,
 *   minAmount: string,
 *   maxAmount: string,
 *   currency: object|null
 * }}
 */
export const normalizeBudget = (budget) => {
  // Default shape
  const defaultBudget = {
    discloseBudget: false,
    amount: "",
    minAmount: "",
    maxAmount: "",
    currency: null,
  };

  if (!budget) return defaultBudget;

  let parsed;

  // Handle stringified JSON
  if (typeof budget === "string") {
    try {
      parsed = JSON.parse(budget);
    } catch (e) {
      return defaultBudget;
    }
  } else if (typeof budget === "object") {
    parsed = budget;
  } else {
    return defaultBudget;
  }

  return {
    discloseBudget: Boolean(parsed.discloseBudget),
    amount: parsed.amount ?? "",
    minAmount: parsed.minAmount ?? "",
    maxAmount: parsed.maxAmount ?? "",
    currency: parsed.currency ?? null,
  };
};
